const PRESENTATIONS = {
  recipient_profile: {
    label: "Assigned to recipient",
    checkoutEligible: true,
  },
  unassigned_gift: {
    label: "Gift purchased for another recipient — code required",
    checkoutEligible: false,
  },
  legacy_unverified: {
    label: "Legacy voucher — ownership unverified",
    checkoutEligible: false,
  },
};

export const voucherOwnershipPresentation = (voucher = {}) => {
  const explicitStatus = voucher.assignment_status || voucher.profile_assignment_status;
  const assignmentStatus = PRESENTATIONS[explicitStatus]
    ? explicitStatus
    : voucher.recipient_client_id
      ? "recipient_profile"
      : "legacy_unverified";
  return { assignmentStatus, ...PRESENTATIONS[assignmentStatus] };
};
